<template>
  <div class="flex-column justify-content-start align-items-center mcontainer">
    <top-bar :title="'活动发布'" :show-back="true" @back="leftClick"></top-bar>
    <div
      class="main-content-p0"
      style="background-color: #ffffff;height: calc(100vh - 2.4rem)"
    >
      <div class="flex-row justify-content-start align-items-center item wv100">
        <i class="label" style="width: 1.7rem;text-align: right">活动名称</i>
        <input
          class="input w100"
          v-model="activityName"
          placeholder="活动名称"
          style="padding-left: 0.3rem;width: calc(100% - 1.7rem)"
        />
      </div>
      <b style="width: 98vw;height: 0.01rem;background-color: #E7E7E7"></b>
      <div class="flex-row justify-content-start align-items-center item wv100">
        <i class="label" style="width: 1.7rem;text-align: right">活动类型</i>
        <input
          readonly
          class="label"
          v-model="activityType.label"
          placeholder="活动类型"
          style="padding-left: 0.3rem;padding-right: 0.3rem;width: calc(100% - 2.7rem)"
        />
        <img
          :src="activity_type"
          alt=""
          style="width: 0.5rem"
          @click="showActivityType = true"
        />
      </div>
      <b style="width: 98vw;height: 0.01rem;background-color: #E7E7E7"></b>
      <div class="flex-row justify-content-start align-items-center item wv100">
        <i class="label" style="width: 1.7rem;text-align: right">参与人数</i>
        <input
          class="input w100"
          v-model="pax"
          type="number"
          placeholder="最大参与人数"
          style="padding-left: 0.3rem;width: calc(100% - 1.7rem)"
        />
      </div>
      <b style="width: 98vw;height: 0.01rem;background-color: #E7E7E7"></b>
      <div class="flex-row justify-content-start align-items-center item wv100">
        <i class="label" style="width: 1.7rem;text-align: right">活动时间</i>
        <!--          <input-->
        <!--              readonly-->
        <!--              class="input w100"-->
        <!--              v-model="startTime"-->
        <!--              placeholder="开始时间"-->
        <!--              style="padding-left: 0.3rem;width: calc(50% - 1.65rem);text-align: right"-->
        <!--          />-->
        <el-date-picker
          :style="{
            width: 'calc(50% - 1.50rem)',
            marginLeft: '0.2rem',
            textAlign: 'right'
          }"
          v-model="startTime"
          type="date"
          size="mini"
          placeholder="开始时间"
        >
        </el-date-picker>
        <i style="width: 0.6rem;text-align: center">至</i>
        <el-date-picker
          :style="{ width: 'calc(50% - 1.50rem)', textAlign: 'right' }"
          v-model="endTime"
          type="date"
          size="mini"
          placeholder="结束时间"
        >
        </el-date-picker>
        <!--          <input-->
        <!--              readonly-->
        <!--              class="input w100"-->
        <!--              v-model="endTime"-->
        <!--              placeholder="结束时间"-->
        <!--              style="width: calc(50% - 1.65rem)"-->
        <!--          />-->
        <!--          <img-->
        <!--              :src="iconTime"-->
        <!--              alt=""-->
        <!--              style="width: 0.5rem"-->
        <!--              @click="showStartDate = true"-->
        <!--          />-->
      </div>
      <b style="width: 98vw;height: 0.01rem;background-color: #E7E7E7"></b>
      <div class="flex-row justify-content-start align-items-center item wv100">
        <i class="label" style="width: 1.7rem;text-align: right">活动地点</i>
        <!--          <i-->
        <!--              class="label"-->
        <!--              style="padding-left: 0.29rem;width: calc(100% - 2.7rem)"-->
        <!--          >-->
        <!--            {{ eventLocation }}-->
        <!--          </i>-->
        <input
          readonly
          class="label"
          v-model="address.descAddress"
          :placeholder="address.title"
          style="padding-left: 0.3rem;padding-right: 0.3rem;width: calc(100% - 2.7rem)"
        />
        <img
          :src="iconCity"
          alt=""
          style="width: 0.5rem"
          @click="showAddress = true"
        />
      </div>
      <b style="width: 98vw;height: 0.01rem;background-color: #E7E7E7"></b>
      <div class="flex-row justify-content-start align-items-center item wv100">
        <i class="label" style="width: 1.7rem;text-align: right">联系电话</i>
        <input
          class="input w100"
          v-model="phone"
          placeholder="联系电话"
          type="number"
          style="padding-left: 0.3rem;width: calc(100% - 1.7rem)"
        />
      </div>
      <!--        <b style="width: 98vw;height: 0.01rem;background-color: #E7E7E7"></b>-->
      <!--        <div-->
      <!--            class="flex-row justify-content-start align-items-center item wv100"-->
      <!--        >-->
      <!--          <i class="label" style="width: 1.7rem;text-align: right">主办单位</i>-->
      <!--          <input-->
      <!--              class="input w100"-->
      <!--              v-model="organizer"-->
      <!--              placeholder="主办单位"-->
      <!--              style="padding-left: 0.3rem;width: calc(100% - 1.7rem)"-->
      <!--          />-->
      <!--        </div>-->
      <div
        class="flex-column w100"
        style="margin-top: 0.2rem;background-color: #ffffff"
      >
        <div class="flex-column wv100">
          <div
            class="flex-row justify-content-start align-items-center w100"
            style="margin-top: 0.1rem"
          >
            <i class="label" style="width: 1.7rem;text-align: right"
              >活动简介</i
            >
          </div>
          <textarea
            v-model="activityIntroduction"
            rows="3"
            placeholder="活动简介"
            style="
              width: calc(100% - 0.7rem);
              padding: 0.2rem 0.2rem 0.2rem 0.24rem;
              background-color: rgb(252, 252, 252);
              margin-left: 0.35rem;"
          ></textarea>
        </div>
      </div>
      <div class="flex-row justify-content-start align-items-center item wv100"
           v-if="ejLeague && ejLeague.role === '3'">
        <i class="label" style="width: 1.7rem;text-align: right">活动上线</i>
        <div
          class="flex-row justify-content-end align-items-center"
          style="width: calc(100% - 1.7rem);padding-right: 0.4rem"
        >
          <el-switch
            v-model="isGoOnline"
            active-text="上线"
            inactive-text="下线"
          >
          </el-switch>
        </div>
      </div>
      <div
        class="flex-column w100"
        style="margin-top: 0.2rem;background-color: #ffffff"
      >
        <div class="flex-column wv100">
          <div
            class="flex-row justify-content-start align-items-center w100"
            style="margin-top: 0.1rem"
          >
            <i class="label" style="width: 1.7rem;text-align: right"
              >活动海报</i
            >
          </div>
          <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :multiple="false"
            :auto-upload="false"
            :on-change="onChange"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </div>
      <div
        class="flex-column justify-content-center align-items-center sibment"
        @click="send"
      >
        <b style="">修改|提交</b>
      </div>
    </div>
    <div
      style="position: fixed;z-index: 888;background-color: #000000E0;top: 1.7rem"
      v-show="showAddress"
    >
      <baidu-map @selectAddress="selectAddress"></baidu-map>
    </div>
    <div
      style="width:100vw;height:100vh;position: fixed;z-index: 888;background-color: #000000E0;top: 0"
      v-show="showActivityType"
    >
      <div
        class="flex-column justify-content-start align-items-center"
        style="margin-top:100%;height: 50%;bottom: 0;background-color: #FFF"
      >
        <div
          v-for="(item, index) in activityTypeArr"
          :key="index"
          class="flex-row justify-content-center align-items-center type-item"
          @click="clickActivityType($event, item)"
        >
          <h1>{{ item.label }}</h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import topBar from "../top-bar/index2";
import iconTime from "@assets/home_new/activity/icon-time.png";
import iconCity from "@assets/home_new/activity/icon-city.png";
import activity_type from "@assets/home_new/activity/activity-type.png";
import BaiduMap from "@components/BaiduMap";
import { getDicts, getActivity, uploadActivity } from "@/api/home";
import { checkAuthInfo } from "@/api/user";

import { VUE_APP_API_URL } from "@utils";

export default {
  name: "activity",
  components: {
    topBar,
    BaiduMap
  },
  data() {
    return {
      isGoOnline: false,
      data: "",
      show: false,
      organizer: "",
      phone: "",
      startTime: "",
      endTime: "",
      activityType: {},
      activityTypeArr: [],
      pax: null,
      dragValue: null,
      showActivityType: false,
      selectDragAttribute: {
        popover: {
          visibility: "hover",
          isInteractive: false
        }
      },
      timeAccuracy: 3,
      attributes: [
        {
          highlight: "blue",
          dates: [
            new Date(2023, 8, 20),
            [new Date(2023, 8, 20), new Date(2023, 8, 26)]
          ]
        }
      ],
      date: {
        start: new Date(2023, 8, 20),
        end: new Date(2023, 8, 26)
      },
      showAddress: false,
      address: { title: "选择地址" },
      value1: "",
      iconTime: iconTime,
      iconCity: iconCity,
      activity_type: activity_type,
      activityName: "",
      activityIntroduction: "",
      eventLocation: "",
      imageUrl: "",
      file: "",
      activityId: '',
      addressInfo: undefined,
      ejLeague: {}
    };
  },
  created() {
    this.route = this.$route.query;
    this.initData();
  },
  mounted() {},
  destroyed() {},
  methods: {
    leftClick() {
      if (this.showAddress) {
        this.showAddress = false;
      } else {
        this.$router.go(-1);
      }
    },
    initData() {
      var _this = this;
      if (this.route.id) {
        _this.$dialog.loading.open();
        checkAuthInfo({})
          .then(res => {
            if (res.code === 1000) {
              this.ejLeague = res.result;
              this.isGoOnline = this.ejLeague.pubFlag === "3";
            }
          })
          .catch(e => {

          });
        getActivity({ id: this.route.id })
          .then(res => {
            console.info(res);
            _this.data = res[this.route.id][0];
            _this.activityName = _this.data.activityTitle;
            _this.activityId = _this.data.activityId;
            _this.activityIntroduction = _this.data.descText;
            _this.startTime = _this.data.beginDate;
            _this.endTime = _this.data.endDate;
            _this.address.descAddress = _this.data.addr;
            _this.phone = _this.data.tel;
            _this.pax = _this.data.pax;
            _this.imageUrl =
              `${VUE_APP_API_URL}` + "/home/getImage?id=" + _this.data.image;
            _this.address.point = {};
            _this.address.point.lat = _this.data.latitude;
            _this.address.point.lng = _this.data.longitude;
            for (const activityType of this.activityTypeArr) {
              if (activityType.value === _this.data.activityType) {
                _this.activityType = activityType;
              }
            }
          })
          .catch(e => {
            console.info(e);
            _this.$message.error("网络请求异常!" + e);
          });
      }
      getDicts({ dictName: "activity_type" })
        .then(res => {
          _this.$dialog.loading.close();
          console.info(res);
          _this.activityTypeArr = res;
        })
        .catch(e => {
          _this.$dialog.loading.close();
          console.info(e);
          _this.$message.error("网络请求异常!" + e);
        });
    },
    send() {
      if (!this.activityName) {
        this.$dialog.toast({ mes: "请输入活动名称" });
        return;
      }
      if (this.activityName.length > 10) {
        this.$dialog.toast({ mes: "请输入活动名称不大于10个字符" });
        return;
      }
      if (!this.activityType.value) {
        this.$dialog.toast({ mes: "请选择活动类型" });
        return;
      }
      if (!this.pax) {
        this.$dialog.toast({ mes: "请输入最大参与人数" });
        return;
      }
      if (this.pax > 10000000) {
        this.$dialog.toast({ mes: "请输入最大参与人数,最大8位数" });
        return;
      }
      if (!this.startTime) {
        this.$dialog.toast({ mes: "请选择开始时间" });
        return;
      }
      if (!this.endTime) {
        this.$dialog.toast({ mes: "请选择结束时间" });
        return;
      }
      if (!this.address.descAddress) {
        this.$dialog.toast({ mes: "请选择活动地点" });
        return;
      }
      if (!this.phone) {
        this.$dialog.toast({ mes: "请输入联系电话" });
        return;
      }
      if (this.phone.length !== 11) {
        this.$dialog.toast({ mes: "请输入11位手机号码" });
        return;
      }
      if (!this.activityIntroduction) {
        this.$dialog.toast({ mes: "请输入活动简介" });
        return;
      }
      if (this.activityIntroduction.length > 30) {
        this.$dialog.toast({ mes: "请输入活动简介内容不大于30个字符" });
        return;
      }
      // if (!this.organizer) {
      //   this.$dialog.toast({mes: "请输入主办单位"});
      //   return;
      // }
      if (!this.file) {
        this.$dialog.toast({ mes: "请选择活动海报" });
        return;
      }

      var _this = this;
      var type = "";
      let imgfile = new FormData();
      imgfile.append("files", _this.file.raw);
      imgfile.append("type", type);
      imgfile.append("activityType", _this.activityType.value);
      imgfile.append("pax", _this.pax);
      imgfile.append("startTime", _this.startTime.getTime());
      imgfile.append(
        "address",
        JSON.stringify({
          title: this.address.descAddress,
          lat: this.address.point.lat,
          lng: this.address.point.lng
        })
      );
      imgfile.append("endTime", _this.endTime.getTime());
      imgfile.append("activityName", _this.activityName);
      imgfile.append("activityId", _this.activityId);
      imgfile.append("phone", _this.phone);
      imgfile.append("activityIntroduction", _this.activityIntroduction);
      imgfile.append("organizer", _this.organizer);
      _this.$dialog.loading.open();
      uploadActivity(imgfile)
        .then(res => {
          _this.$dialog.loading.close();
          console.info(res);
          _this.$dialog.loading.close();
          _this.$tip({
            show: true,
            message: "提交成功"
          });
          _this.clear();
        })
        .catch(e => {
          _this.$dialog.loading.close();
          _this.$tip({
            show: true,
            message: e.message
          });
        });

      // this.$axios({
      //   url: `${VUE_APP_API_URL}/activity/uploadActivity`,
      //   method: "post",
      //   data: imgfile,
      //   headers: {
      //     "Content-Type": "multipart/form-data"
      //   }
      // })
      //     .then(function (res) {
      //       if (res.status === 200) {
      //         console.info(res);
      //         _this.$dialog.loading.close();
      //         _this.$message.success("提交成功");
      //         _this.clear();
      //       } else {
      //         _this.$message.error("提交失败");
      //       }
      //     })
      //     .catch(function (err) {
      //       _this.$dialog.loading.close();
      //       _this.$message.error("网络请求异常!" + err);
      //     });
      //
      // uploadActivity(imgfile)
      //     .then(res => {
      //       console.info(res);
      //       _this.clear()
      //     })
      //     .catch(e => {
      //       console.info(e);
      //     });
    },
    clickActivityType($event, item) {
      this.activityType = item;
      this.showActivityType = false;
    },
    clear() {
      this.activityName = "";
      this.startTime = "";
      this.pax = "";
      this.endTime = "";
      this.activityType = {};
      this.address = {
        title: "活动地点"
      };
      this.phone = "";
      this.activityIntroduction = "";
      this.organizer = "";
      this.file = "";
      this.imageUrl = "";
    },
    selectAddress(address) {
      this.showAddress = false;
      this.address = address;
      console.info(address);
    },
    confirmMapAddress(addressInfo) {
      this.addressInfo = addressInfo;
    },
    onChange(file, fileList) {
      this.file = file;
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG|png 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/flex.css";
@import "../../assets/css/font-title.css";
@import "../../assets/css/msg.css";

.mcontainer {
  background-color: #f1f1f1;
  /*background: url(../../assets/home_new/activity/back4.jpg);*/
  background-size: 100% auto;
  background-repeat: no-repeat;
}

.type-item {
  margin-top: 5px;
  background-color: #fff;
  width: 100%;
  min-height: 0.6rem;
  padding: 5px 20px 5px 20px;
}

>>> .el-input--suffix .el-input__inner {
  padding-right: 0;
}

.sibment {
  background: linear-gradient(to right, #0eb1ff, #0d75fe);
  margin: 0.2rem;
  width: calc(100% - 0.4rem);
  height: 0.77rem;
  color: #ffffff;
  border-radius: 0.1rem;
}

.item {
  height: 0.98rem;
}

.avatar-uploader .el-upload {
  border: 1px dashed #c1a6a6;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar {
  width: 2rem;
  height: 2rem;
  margin-left: 0.3rem;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  text-align: center;
}
</style>
